<template>
  <div class="editor-popover-notification" v-if="text">
    <Icon iconStyle="fas" icon="fa-exclamation-triangle" iconClass="text-danger" fixedWidth />
    <span class="text-danger ml-1">{{text}}</span>
  </div>
</template>

<style scoped>
.editor-popover-notification {
  font-size: 0.65rem;
}
</style>


<script>
export default {
  name: 'EditorPopoverNotification',
  props: {
    text: String
  }
}
</script>